import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

import { Entity } from 'src/compass/site/util';

const entity = Entity.EMPLOYEE_RISK_MANAGER;

export function CasRHFRiskManagerSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasRiskManagerSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
